// extracted by mini-css-extract-plugin
export default {"ag-styles":"d_g","aboutPage":"d_q","team":"d_r","footer":"d_s"};